/**
 * 密码安全等级
 */
export var PasswordSecurityLevel;
(function (PasswordSecurityLevel) {
    PasswordSecurityLevel[PasswordSecurityLevel["LOW"] = 1] = "LOW";
    PasswordSecurityLevel[PasswordSecurityLevel["MIDDLE"] = 2] = "MIDDLE";
    PasswordSecurityLevel[PasswordSecurityLevel["HIGH"] = 3] = "HIGH";
})(PasswordSecurityLevel || (PasswordSecurityLevel = {}));
export var SocialConnectionProvider;
(function (SocialConnectionProvider) {
    SocialConnectionProvider["ALIPAY"] = "alipay";
    SocialConnectionProvider["GOOGLE"] = "google";
    SocialConnectionProvider["WECHATPC"] = "wechat:pc";
    SocialConnectionProvider["WECHATMP"] = "wechat:webpage-authorization";
    SocialConnectionProvider["WECHAT_MINIPROGRAM"] = "wechat:miniprogram:default";
    SocialConnectionProvider["WECHAT_MINIPROGRAM_QRCODE"] = "wechat:miniprogram:qrconnect";
    SocialConnectionProvider["WECHAT_MINIPROGRAM_APPLAUNCH"] = "wechat:miniprogram:app-launch";
    SocialConnectionProvider["WECHATMOBILE"] = "wechat:mobile";
    SocialConnectionProvider["GITHUB"] = "github";
    SocialConnectionProvider["QQ"] = "qq";
    SocialConnectionProvider["WECHATWORK_ADDRESS_BOOK"] = "wechatwork:addressbook";
    SocialConnectionProvider["WECHATWORK_CORP_QRCONNECT"] = "wechatwork:corp:qrconnect";
    SocialConnectionProvider["WECHATWORK_SERVICEPROVIDER_QRCONNECT"] = "wechatwork:service-provider:qrconnect";
    SocialConnectionProvider["DINGTALK"] = "dingtalk";
    SocialConnectionProvider["WEIBO"] = "weibo";
    SocialConnectionProvider["APPLE"] = "apple";
    SocialConnectionProvider["APPLE_WEB"] = "apple:web";
    SocialConnectionProvider["OAUTH"] = "oauth";
})(SocialConnectionProvider || (SocialConnectionProvider = {}));
export var Protocol;
(function (Protocol) {
    Protocol["OIDC"] = "oidc";
    Protocol["OAUTH"] = "oauth";
    Protocol["SAML"] = "saml";
    Protocol["CAS"] = "cas";
    Protocol["AZURE_AD"] = "azure-ad";
})(Protocol || (Protocol = {}));
export var AppPasswordStrengthLimit;
(function (AppPasswordStrengthLimit) {
    AppPasswordStrengthLimit[AppPasswordStrengthLimit["NoCheck"] = 0] = "NoCheck";
    AppPasswordStrengthLimit[AppPasswordStrengthLimit["Low"] = 1] = "Low";
    AppPasswordStrengthLimit[AppPasswordStrengthLimit["Middle"] = 2] = "Middle";
    AppPasswordStrengthLimit[AppPasswordStrengthLimit["High"] = 3] = "High";
})(AppPasswordStrengthLimit || (AppPasswordStrengthLimit = {}));
export var RegisterMethods;
(function (RegisterMethods) {
    RegisterMethods["Email"] = "email";
    RegisterMethods["Phone"] = "phone";
})(RegisterMethods || (RegisterMethods = {}));
export var LoginMethods;
(function (LoginMethods) {
    LoginMethods["LDAP"] = "ldap";
    LoginMethods["AppQr"] = "app-qrcode";
    LoginMethods["Password"] = "password";
    LoginMethods["PhoneCode"] = "phone-code";
    LoginMethods["WxMinQr"] = "wechat-miniprogram-qrcode";
    LoginMethods["AD"] = "ad"; // 对应企业身份源的 Windows AD 登录
})(LoginMethods || (LoginMethods = {}));
export var OIDCConnectionMode;
(function (OIDCConnectionMode) {
    OIDCConnectionMode["FRONT_CHANNEL"] = "FRONT_CHANNEL";
    OIDCConnectionMode["BACK_CHANNEL"] = "BACK_CHANNEL";
})(OIDCConnectionMode || (OIDCConnectionMode = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2F1dGhlbnRpY2F0aW9uL3R5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQStIQTs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLHFCQUlYO0FBSkQsV0FBWSxxQkFBcUI7SUFDL0IsK0RBQU8sQ0FBQTtJQUNQLHFFQUFVLENBQUE7SUFDVixpRUFBUSxDQUFBO0FBQ1YsQ0FBQyxFQUpXLHFCQUFxQixLQUFyQixxQkFBcUIsUUFJaEM7QUFnQkQsTUFBTSxDQUFOLElBQVksd0JBbUJYO0FBbkJELFdBQVksd0JBQXdCO0lBQ2xDLDZDQUFpQixDQUFBO0lBQ2pCLDZDQUFpQixDQUFBO0lBQ2pCLGtEQUFzQixDQUFBO0lBQ3RCLHFFQUF5QyxDQUFBO0lBQ3pDLDZFQUFpRCxDQUFBO0lBQ2pELHNGQUEwRCxDQUFBO0lBQzFELDBGQUE4RCxDQUFBO0lBQzlELDBEQUE4QixDQUFBO0lBQzlCLDZDQUFpQixDQUFBO0lBQ2pCLHFDQUFTLENBQUE7SUFDVCw4RUFBa0QsQ0FBQTtJQUNsRCxtRkFBdUQsQ0FBQTtJQUN2RCwwR0FBOEUsQ0FBQTtJQUM5RSxpREFBcUIsQ0FBQTtJQUNyQiwyQ0FBZSxDQUFBO0lBQ2YsMkNBQWUsQ0FBQTtJQUNmLG1EQUF1QixDQUFBO0lBQ3ZCLDJDQUFlLENBQUE7QUFDakIsQ0FBQyxFQW5CVyx3QkFBd0IsS0FBeEIsd0JBQXdCLFFBbUJuQztBQUVELE1BQU0sQ0FBTixJQUFZLFFBTVg7QUFORCxXQUFZLFFBQVE7SUFDbEIseUJBQWEsQ0FBQTtJQUNiLDJCQUFlLENBQUE7SUFDZix5QkFBYSxDQUFBO0lBQ2IsdUJBQVcsQ0FBQTtJQUNYLGlDQUFxQixDQUFBO0FBQ3ZCLENBQUMsRUFOVyxRQUFRLEtBQVIsUUFBUSxRQU1uQjtBQUVELE1BQU0sQ0FBTixJQUFZLHdCQUtYO0FBTEQsV0FBWSx3QkFBd0I7SUFDbEMsNkVBQU8sQ0FBQTtJQUNQLHFFQUFHLENBQUE7SUFDSCwyRUFBTSxDQUFBO0lBQ04sdUVBQUksQ0FBQTtBQUNOLENBQUMsRUFMVyx3QkFBd0IsS0FBeEIsd0JBQXdCLFFBS25DO0FBRUQsTUFBTSxDQUFOLElBQVksZUFHWDtBQUhELFdBQVksZUFBZTtJQUN6QixrQ0FBZSxDQUFBO0lBQ2Ysa0NBQWUsQ0FBQTtBQUNqQixDQUFDLEVBSFcsZUFBZSxLQUFmLGVBQWUsUUFHMUI7QUFFRCxNQUFNLENBQU4sSUFBWSxZQU9YO0FBUEQsV0FBWSxZQUFZO0lBQ3RCLDZCQUFhLENBQUE7SUFDYixvQ0FBb0IsQ0FBQTtJQUNwQixxQ0FBcUIsQ0FBQTtJQUNyQix3Q0FBd0IsQ0FBQTtJQUN4QixxREFBcUMsQ0FBQTtJQUNyQyx5QkFBUyxDQUFBLENBQUMseUJBQXlCO0FBQ3JDLENBQUMsRUFQVyxZQUFZLEtBQVosWUFBWSxRQU92QjtBQThDRCxNQUFNLENBQU4sSUFBWSxrQkFHWDtBQUhELFdBQVksa0JBQWtCO0lBQzVCLHFEQUErQixDQUFBO0lBQy9CLG1EQUE2QixDQUFBO0FBQy9CLENBQUMsRUFIVyxrQkFBa0IsS0FBbEIsa0JBQWtCLFFBRzdCIn0=